export const getSortedProducts = (products, sortType) => {
    const sorted = [...products];

    switch (sortType) {
        case 'name':
            return sorted.sort((a, b) =>
                (a.productName || '').localeCompare(b.productName || '', 'he')
            );
        case 'price':
            return sorted.sort((a, b) => (a.price || 0) - (b.price || 0));
        case 'sale':
            return sorted.sort((a, b) => {
                const aOnSale = a.onSale || a.salePrice || false;
                const bOnSale = b.onSale || b.salePrice || false;
                if (aOnSale && !bOnSale) return -1;
                if (!aOnSale && bOnSale) return 1;
                return 0;
            });
        default:
            return sorted;
    }
};
